module.exports = __webpack_public_path__ + "img/BankID-iphone-small.336cd411.png";